import { useState, useEffect, useRef } from "react";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import { LoadPanel } from "devextreme-react/load-panel";
import { config } from "../config";
import notify from "devextreme/ui/notify";
import api from "../request/api";
import baner from "../Assets/baner.png";
import ReCAPTCHA from 'react-google-recaptcha';

const StatusFeedback = () => {
  const [stringNumer, setStringNumber] = useState();
  const [feedback, setFeedback] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showEmptyStatus, setShowEmptyStatus] = useState(false);
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const statusRef = useRef();

  const reference = useRef();

  const checkStatusHandle = () => {
    submitData();
  };

  const submitData = async () => {
    reference.current.reset();
    setTokenIsValid(false);
    if (!stringNumer) {
      notify("Proszę wpisać numer sprawy", "error", 5000);
    } else {
      setIsLoading(true);
      let param = {
        stringNumber: stringNumer
      };
      const { data } = await api.post(config.apiUrl + "Feedback/Check", param);

      if (data) {
        setFeedback(data);
        setIsLoading(false);
        statusRef.current.scrollIntoView(
          {
            behavior: "smooth",
            block: "nearest",
            inline: "start"
          }
        )
      } else {
        setIsLoading(false);
        notify(
          "Nie znaleziono sprawy o numerze: " + stringNumer + ", Przykład: R/00001/2017",
          "error",
          10000
        );
      }
    }
  };
  const onChange = async (e) => {
    const { data } = await api.post(config.apiUrl + "Feedback/CheckRecaptcha", { token: e });
    if (data) {
      setTokenIsValid(data.success)
    } else {
      setTokenIsValid(false);
    }
  }
  return (
    <>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={isLoading}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
      <div className="card">
        <div className="col-12">
          <div
            className="mainHeader"
            style={{ backgroundImage: `url(${baner})` }}
          >
            =
          </div>
        </div>
        <div className="row status">
          <div className="statusWrap">
            <div className="col-12 col-xl-12">
              <div className="col-12 secendaryHeader">
                <span className="secendaryHeaderText">
                  Sprawdź status zgłoszenia/reklamacji
                </span>
              </div>
              <div className="section">
                <label htmlFor="StringNumber">Numer sprawy</label>
                <TextBox
                  id="StringNumber"
                  inputAttr={{ id: 'StringNumber' }}
                  aria-required="true"
                  aria-describedby="StringNumber"
                  onValueChange={(e) => {
                    setStringNumber(e);
                  }}
                />
              </div>
              <p>
                <small className="validationText">*pole wymagane</small>
              </p>
            </div>
            <div className="col-12 col-xl-8" id="recaptchDiv">
              <ReCAPTCHA
                sitekey="6LcOuJggAAAAAJs83fkPfcu7AWeE0V31b9_43fpp"
                onChange={onChange}
                ref={reference}
                lang="pl-PL"
                hl="pl"

              />
            </div>
            <div className="d-flex justify-content-center buttonStatusSection">
              {tokenIsValid &&
                <Button
                  id="button"
                  text="Sprawdź status sprawy"
                  className="buttonSuccess"
                  onClick={checkStatusHandle}
                />
              }
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 answerContent">
          {feedback && (
            <div ref={statusRef}>
              <hr />
              <div className="datarow">
                <div className="col-12 secendaryHeader">
                  <span className="secendaryHeaderText">Stan sprawy</span>
                </div>
                <div className="section p-0">
                  <p className="mainHeaderText">
                    <b>Data zgłoszenia:</b>{" "}
                    {new Date(feedback.addDate).toLocaleDateString()}
                  </p>
                  <p className="mainHeaderText">
                    <b>Status: </b>
                    {feedback.status}
                  </p>
                </div>
              </div>
              <hr />
              <div className="datarow">
                <div className="col-12 secendaryHeader">
                  <span className="secendaryHeaderText">Pracownik prowadzący sprawę</span>
                </div>
                <div className="section p-0">
                  <p className="mainHeaderText">
                    <b>Imię:</b>{" "}
                    {feedback.employeeName}
                  </p>
                  <p className="mainHeaderText">
                    <b>Nazwisko:</b>{" "}
                    {feedback.employeeSurname}
                  </p>
                  <p className="mainHeaderText">
                    <b>E-mail: </b>{" "}
                    {feedback.employeeEmail}
                  </p>
                  <p className="mainHeaderText">
                    <b>Telefon: </b>{" "}
                    {feedback.EmployeePhone}
                  </p>
                </div>
              </div>
            </div>
          )}
          {showEmptyStatus && (
            <>
              <div className="col-12 secendaryHeader emptyAnswer">
                <span className="secendaryHeaderText ">
                  Brak sprawy o takim numerze
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export { StatusFeedback };
